export const inputChecks = (value, id) => {
    const year = id.includes('year')
    if (year) id = 'year'

    const engineNumber = id.includes('engineNumber') || id.includes('chassisNumber')
    if (engineNumber) id = 'engineNumber'

    switch (id) {
        case 'phone':
        case 'branchNumber':
        case 'year':
            return value.replace(/[^0-9]/, '')
        case 'lastName':
        case 'firstName':
        case 'jobTitle':
            return value.replace(/[^a-zA-Z0-9-. ]/g, '')
        case 'state':
            return value.replace(/[^a-zA-Z ]/g, '')
        case 'zip':
            return value.replace(/[^A-Za-z0-9\- ]+$/, '')
        case 'businessEmailId':
            return value.replace(/[^A-Za-z0-9\-@._]+$/, '')
        case 'engineNumber':
            return value.replace(/[^\w\s]|_/gi, '')
        case 'totalPieces':
            return value >= 0 ? value : '' || 0
        case 'Promocode':
            return value.replace(/\D/g, '')
        case 'declaredValue':
            return value.replace(/(?<!\d)\.|\.(?=\d*\.\d+)/g, '').replace(/[^\d.]/g, '')
        case 'QuoteSRANumber':
            return value.replace(/\D/g, '')
        default:
            return value
    }
}
